import { Grid } from "@mui/material";
import React from "react";
import { Input, InputAuto } from "../../../controls";
import { Countries } from "../../../hooks/Countries";

const AddressFields = ({ values, handleInpChg }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <InputAuto
          label="Country"
          name="country"
          value={values.country}
          onChange={handleInpChg}
          options={Countries}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input
          label="City"
          name="city"
          value={values.city}
          inputProps={{ maxLength: 150 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input
          label="State"
          name="state"
          value={values.state}
          inputProps={{ maxLength: 150 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input
          label="ZIP"
          name="zip"
          value={values.zip}
          inputProps={{ maxLength: 50 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input
          label="Address Line 1"
          name="address1"
          value={values.address1}
          inputProps={{ maxLength: 300 }}
          multiline
          rows={2}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input
          label="Address Line 2"
          name="address2"
          value={values.address2}
          inputProps={{ maxLength: 300 }}
          multiline
          rows={2}
          onChange={handleInpChg}
        />
      </Grid>
    </Grid>
  );
};

export default AddressFields;
